export const useSecondaryPage = async (options) => {
  const datoHelperClient = useDatoHelper()
  const currentLocale = useLocale() || 'en'
  let query = null
  if (options.isCountyPage) {
    query = `query MyQuery {
      country: ${options.datoPageName}(locale: ${currentLocale}, filter: {${options.slug.name}: {eq: "${options.slug.value}"}}) {
          ${options.queryName}
      }
      default: ${options.datoPageName}(locale: ${currentLocale}, filter: {${options.slug.name}: {eq: "default"}}) {
        ${options.queryName}
      }
      unsupported: ${options.datoPageName}(locale: ${currentLocale}, filter: {${options.slug.name}: {eq: "unsupported"}} ) {
        ${options.queryName}
      }
    }`
  } else if (options.slug) {
    query = `query MyQuery {
      ${options.datoPageName}(locale: ${currentLocale}, filter: {${options.slug.name}: {eq: "${options.slug.value}"}}) {
          ${options.queryName}
        }
    }`
  } else {
    query = `query MyQuery {
      ${options.datoPageName}(locale: ${currentLocale}) {
          ${options.queryName}
        }
      }`
  }
  
  const response = await datoHelperClient.request(query, options.fieldName + currentLocale)

  if (options.isCountyPage) {
    if (response.country) {
      return response.country
    } else if (options.isServiceUnsuppored) {
      return response.unsupported
    } else {
      return response.default
    }
  }
  return response[options.datoPageName]
}
